<template>
  <div>
    <highcharts ref="chart" :options="options" />
    <br />
    <b-table
      :striped="true"
      :narrowed="true"
      :hoverable="true"
      :data="values"
      :columns="columns"
    />
  </div>
</template>

<script>
import '@/plugins/highcharts.js'
import { useCoreStore } from '../../stores/core'

export default {
  name: 'TravelsPurposesEmissionsBar',
  props: {
    ghgi: {
      type: Object,
      default: null
    }
  },
  setup () {
    let coreStore = useCoreStore()
    return { coreStore }
  },
  computed: {
    purposes: function () {
      return this.coreStore.travelPurposeLabels
    },
    values: function () {
      let i = 0
      let values = {
        intensity: '<nobr>' + this.$t('emissions.t.co2e.short') + '</nobr>'
      }
      for (let purpose of this.purposes) {
        values[this.$t(purpose)] =
          '<nobr>' +
          this.$options.filters.splitNumberTons(
            this.ghgi.emissions.travels.purposes.intensity[i].intensity
          )
        values[this.$t(purpose)] +=
          ' +/- ' +
          this.$options.filters.splitNumberTons(
            this.ghgi.emissions.travels.purposes.intensity[i].uncertainty
          ) +
          '/<nobr>'
        i += 1
      }
      return [values]
    },
    columns: function () {
      let columns = [
        {
          field: 'intensity',
          label: '',
          sticky: true
        }
      ]
      for (let purpose of this.purposes) {
        columns.push({
          field: this.$t(purpose),
          label: this.$t(purpose),
          numeric: true
        })
      }
      return columns
    },
    series: function () {
      let series = []
      let intensities = this.ghgi.emissions.travels.purposes.intensity.map(
        (obj) => obj.intensity / 1000
      )
      let uncertainties = this.ghgi.emissions.travels.purposes.intensity.map(
        (obj) => {
          return [
            (obj.intensity + obj.uncertainty) / 1000,
            (obj.intensity - obj.uncertainty) / 1000
          ]
        }
      )
      series.push(
        {
          name: this.$t('emissions.t.co2e.short'),
          data: intensities
        },
        {
          name: this.$t('uncertainty'),
          type: 'errorbar',
          lineWidth: 2,
          data: uncertainties
        }
      )
      return series
    },
    options: function () {
      return {
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        legend: {
          enabled: false
        },
        series: this.series,
        xAxis: {
          categories: this.purposes.map((val) => this.$t(val)),
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t('emissions.t.co2e.short')
          }
        },
        tooltip: {
          shared: true,
          valueDecimals: 2,
          valueSuffix: ' ' + this.$t('t.co2e')
        }
      }
    }
  }
}
</script>

<style>
.is-sticky {
  background: #fafafa !important;
}
.table td {
  vertical-align: middle !important;
}
</style>
